/* JYM — "Add to Cart — $35.99": the button carries the price of what will be added.
   One-time → the price the theme displays (tiered sale price when active). Subscription → the variant price with the
   selected selling plan's first price adjustment (Skio: 20% first order). Impact keeps the buy-box inputs OUTSIDE the
   <form> (associated via the form= attribute) and replaces the button on re-render, so everything is re-queried via
   form.elements on every render. Decision record: docs/pdp-redesign/PLAN.md */
(function () {
  var product = null;
  function form() { return document.querySelector('form[action*="/cart/add"]'); }
  function button() { var f = form(); return f && f.querySelector('button[type=submit]'); }
  function labelOf(b) { return b.querySelector('div') || b; }
  var base = null;

  function money(cents) {
    var fmt = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat;
    if (fmt && window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents, fmt);
    return '$' + (cents / 100).toFixed(2);
  }
  function el(name) { var f = form(); return f && f.elements && f.elements.namedItem(name); }
  function currentVariant() {
    var idInput = el('id'); var id = idInput && parseInt(idInput.value, 10);
    return product && product.variants.find(function (v) { return v.id === id; });
  }
  function displayedOneTime() {
    var e = document.querySelector('.product-info__price sale-price');
    var m = e && e.textContent.replace(/\s+/g, ' ').match(/\$[\d,]+\.\d{2}/);
    return m ? m[0] : null;
  }
  function planPrice(variant, planId) {
    var groups = product.selling_plan_groups || [];
    for (var g = 0; g < groups.length; g++) {
      var plan = groups[g].selling_plans.find(function (p) { return String(p.id) === String(planId); });
      if (!plan) continue;
      var adj = plan.price_adjustments && plan.price_adjustments[0];
      if (!adj) return variant.price;
      if (adj.value_type === 'percentage') return Math.round(variant.price * (100 - adj.value) / 100);
      if (adj.value_type === 'fixed_amount') return variant.price - adj.value;
      if (adj.value_type === 'price') return adj.value;
    }
    return variant.price;
  }
  function render() {
    var b = button(); if (!b) return;
    var label = labelOf(b);
    if (base === null) base = label.textContent.trim().replace(/\s+—.*$/, '') || 'Add to cart';
    if (b.disabled && /sold out|unavailable/i.test(label.textContent)) return;
    var sp = el('selling_plan'); var planId = sp && sp.value;
    var text = base;
    if (planId && product) { var v = currentVariant(); if (v) text = base + ' — ' + money(planPrice(v, planId)); }
    else { var shown = displayedOneTime(); if (shown) text = base + ' — ' + shown; }
    if (label.textContent.trim() !== text) label.textContent = text;
  }
  fetch(location.pathname.replace(/\/$/, '') + '.js').then(function (r) { return r.json(); }).then(function (p) { product = p; render(); }).catch(function () {});
  document.addEventListener('variant:change', function () { setTimeout(render, 60); setTimeout(render, 400); });
  document.addEventListener('product:rerender', function () { setTimeout(render, 80); setTimeout(render, 400); });
  document.addEventListener('change', function () { setTimeout(render, 60); }, true);   // Skio radios (shadow DOM, composed)
  var sp = el('selling_plan');
  if (sp) new MutationObserver(render).observe(sp, { attributes: true, attributeFilter: ['value'] });
  render();
})();
